<script setup lang="ts">
import { useGameStore } from '@/stores/gameStore'
import { computed, ref, onMounted, onUnmounted } from 'vue'
import { useAssetStore } from '@/stores/assetStore.ts'
import CurrentTech from '@/components/Sections/Research/CurrentTech.vue'
import { usePlanetStore } from '@/stores/planetStore.ts'
import GenericIconWithColoredNumber from '@/components/Elements/Images/Icons/GenericIconWithColoredNumber.vue'
import SunkenMetricDisplay from '@/components/Elements/Display/SunkenMetricDisplay.vue'
const gameStore = useGameStore()
const assetStore = useAssetStore()
const planetStore = usePlanetStore()

const showScienceToolTip = ref(false)
const containerRef = ref<HTMLElement | null>(null)

const toggleTooltip = () => {
  if (gameStore.player?.currentTechId != 0) {
    showScienceToolTip.value = !showScienceToolTip.value
  }
}

const handleClickOutside = (event: MouseEvent) => {
  if (containerRef.value && !containerRef.value.contains(event.target as Node)) {
    showScienceToolTip.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

const techPercentage = computed(() => {
  const tech = assetStore.findTechById(Number(gameStore.player?.currentTechId))
  if (!tech) {
    return 0
  }
  
  let costToUse = tech.cost
  if (gameStore.playerPrototypes.has(tech.id) && gameStore.player?.effectiveAllianceResearchCostMultiplier) {
    costToUse = Math.ceil(tech.cost * gameStore.player.effectiveAllianceResearchCostMultiplier)
  }
  
  const percentage = Math.floor((Number(gameStore.player?.sciencePoints) / costToUse) * 100)
  if (percentage > 100) {
    return 100
  }
  return percentage
})

const scienceOutput = computed(() => {
  if (gameStore.websocketInitialSyncCompleted) {
    return planetStore.getTotalScienceOutput()
  }
  return 0
})
</script>

<template>
  <div ref="containerRef" class="hidden sm:block">
    <div class="flex-col">
      <div v-if="showScienceToolTip" class="current-tech">
        <CurrentTech></CurrentTech>
      </div>
      <SunkenMetricDisplay
        :gradient="true"
        variant="bottomBar"
        :clickable="true"
        @click="toggleTooltip"
      >
        <div class="pr-2">
          <GenericIconWithColoredNumber :amount="scienceOutput" type="science" />
        </div>
        <div class="text-metal-300 text-xs">
          <span v-if="gameStore.player?.currentTechId != 0">{{ techPercentage }}%</span>
          <span v-else>-</span>
        </div>
      </SunkenMetricDisplay>
    </div>
  </div>
</template>

<style scoped>
.current-tech {
  position: absolute;
  bottom: 2.5rem;
  z-index: 50;
}
</style>